import { CurrencyPipe, DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as FileSaver from 'file-saver';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

import { environment } from '@app/env-service';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class RfqClientService {
  url :string = environment.url;

  curPipe :CurrencyPipe;
  datePipe :DatePipe;

  excelFileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  excelFileExtension = '.xlsx';

  private readonly _records = new BehaviorSubject<any>(<any>[]);
  public records$ = this._records.asObservable();

  public gettingRecords :boolean = false;

  constructor(
    private translate :TranslateService,
    private http :HttpClient,
  ) {
    this.curPipe = new CurrencyPipe('en');
    this.datePipe = new DatePipe('en');
  }

  get(clientId :number) {
    this.gettingRecords = true;

    return this.http
      .get(`${this.url}/rfq-clients/${clientId}`)
      .subscribe((resp :any) => {
        this.gettingRecords = false;
        this._records.next(resp);
      });
  }

  store(payload :any) :Observable<any> {
    return this.http.post(`${this.url}/rfq-clients`, payload).pipe(
      tap((resp :any) => {
        setTimeout(() => {
          this._records.next(resp);
        });
      }),
    );
  }

  delete(payload :any) {
    return this.http.post(`${this.url}/rfq-clients/remove`, payload).pipe(
      tap((resp :any) => {
        this._records.next(resp);
      }),
    );
  }
}
